import React from 'react'
import Parallax from "@/Plugins/Parallax";


import RweInfosNok from "@/Components/Front/SVGS/RWE/RWE_infos_nok";
import RweMiddleNok from "@/Components/Front/SVGS/RWE/RWE_middle_nok";
import RweTopNok from "@/Components/Front/SVGS/RWE/RWE_top_nok";
import Text from "@/Components/Front/Text";


const ParallaxBAB = ({textProps}) => {

    return (
        <div className={"parallax_ba_item nok"}>
            <div className={"info-parallax-item"}>
                <h1>
                    <Text {...textProps} str={"health-ecosystem-with-data"}/>
                </h1>
            </div>
            <Parallax hoverOnly>
                <RweInfosNok lang={textProps.lang} data-depth={.3}/>
                <RweMiddleNok lang={textProps.lang} data-depth={0.2}/>
                <RweTopNok lang={textProps.lang} data-depth={.1}/>
            </Parallax>
        </div>
    )
}


export default ParallaxBAB
